import { BusinessObjectBase } from './base';
import type { Interview } from './interview';

export interface InterviewStressResistanceData {
  readonly id: number;
  readonly stressResistanceScore?: number;
  readonly notes?: string;
  readonly interviewId: number;
  readonly interview?: Interview;
}

export interface InterviewStressResistance extends Readonly<InterviewStressResistanceData> {}
export class InterviewStressResistance extends BusinessObjectBase {
  static readonly entityName = 'InterviewStressResistance' as const;
  static readonly plural = 'interview-stress-resistances';

  // --- Static CRUD methods ---

  static async find(filter?: any): Promise<InterviewStressResistance[]> {
    const url = `${this.baseUrl}/${this.plural}`;
    const params: Record<string, string> = {};
    if (filter) params['filter'] = JSON.stringify(filter);
    const results = await this.get<any[]>(url, params);
    return results.map((data) => new InterviewStressResistance(data));
  }

  static async findOne(
    filter?: any,
  ): Promise<InterviewStressResistance | null> {
    const url = `${this.baseUrl}/${this.plural}/find-one`;
    const params: Record<string, string> = {};
    if (filter) params['filter'] = JSON.stringify(filter);
    const data = await this.get<any>(url, params);
    return data ? new InterviewStressResistance(data) : null;
  }

  static async findById(
    id: number,
    filter?: any,
  ): Promise<InterviewStressResistance> {
    const url = `${this.baseUrl}/${this.plural}/${id}`;
    const params: Record<string, string> = {};
    if (filter) params['filter'] = JSON.stringify(filter);
    const data = await this.get<any>(url, params);
    return new InterviewStressResistance(data);
  }

  static async create(
    data: Omit<InterviewStressResistanceData, 'id'>,
  ): Promise<InterviewStressResistance> {
    const url = `${this.baseUrl}/${this.plural}`;
    const result = await this.post<any>(url, data);
    return new InterviewStressResistance(result);
  }

  static async updateById(
    id: number,
    data: Partial<InterviewStressResistanceData>,
  ): Promise<InterviewStressResistance> {
    const url = `${this.baseUrl}/${this.plural}/${id}`;
    const result = await this.patch<any>(url, data);
    return new InterviewStressResistance(result);
  }

  static async deleteById(id: number): Promise<boolean> {
    const url = `${this.baseUrl}/${this.plural}/${id}`;
    try {
      await this.del<void>(url);
      return true;
    } catch {
      return false;
    }
  }
}
